module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade modal-toll-ticket",
    attrs: {
      "id": "modal-toll-ticket",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "modal-toll-ticket-label"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title text-center",
    attrs: {
      "id": "modal-toll-ticket-label"
    }
  }, [_vm._v("Emissão de Vale-pedágio (VP)")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {}, [_c('ul', {
    staticClass: "wizard margin-b20 "
  }, [_c('li', {
    class: {
      active: _vm.step == 0, past: _vm.step > 0
    }
  }, [_vm._m(0), _vm._v(" "), _c('medium', [_vm._v("Veículo Agregador")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.step == 1, past: _vm.step > 1
    }
  }, [_vm._m(1), _vm._v(" "), _c('big', [_vm._v("Data e Rotas")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.step == 2, past: _vm.step > 2
    }
  }, [_vm._m(2), _vm._v(" "), _c('big', [_vm._v("Transportador")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.step == 3, past: _vm.step > 3
    }
  }, [_vm._m(3), _vm._v(" "), _c('big', [_vm._v("Confirmação")])], 1)])]), _vm._v(" "), (_vm.msgError) ? _c('div', {
    staticClass: "margin-t30",
    staticStyle: {
      "width": "97%",
      "margin-left": "10px"
    }
  }, [_c('div', {
    staticClass: "alert alert-danger alert-container"
  }, [_c('p', {
    staticClass: "no-margin"
  }, [_vm._v("\n              " + _vm._s(_vm.msgError) + "\n            ")])])]) : _vm._e(), _vm._v(" "), (_vm.step == 0) ? _c('vehicle-aggregate', {
    attrs: {
      "aggregate": _vm.aggregate,
      "contract": _vm.contractShipper
    },
    on: {
      "aggregateData": _vm.aggregateData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step == 1) ? _c('date-route', {
    attrs: {
      "routeIdSelected": _vm.routeSelected,
      "confirmRouteSelected": _vm.confirmRouteSelected,
      "aggregate": _vm.aggregate
    },
    on: {
      "cleanErrors": _vm.cleanErrors,
      "confirmRouteSelected": _vm.callback
    },
    model: {
      value: (_vm.routeSelected),
      callback: function($$v) {
        _vm.routeSelected = $$v
      },
      expression: "routeSelected"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step == 2) ? _c('transportador-rntrc', {
    attrs: {
      "transportadorRntrc": _vm.transportadorRntrc,
      "aggregate": _vm.aggregate
    },
    on: {
      "nxtStep": _vm.nextStep
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step == 3) ? _c('summary-aggregate', {
    attrs: {
      "routeSelected": _vm.routeSelected,
      "aggregate": _vm.aggregate
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step == 4) ? _c('div', {}, [_c('div', {
    staticClass: "content-box success text-center"
  }, [_c('h4', [_vm._v("Vale-pedágio gerado com sucesso!")]), _vm._v(" "), _c('img', {
    staticClass: "margin-10",
    attrs: {
      "src": "/static/Icon-check-circle.svg",
      "alt": "icon-check-circle"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("OK")])])]) : _vm._e()], 1), _vm._v(" "), (_vm.step != 4) ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 0),
      expression: "step == 0"
    }],
    staticClass: "no-btn",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step > 0),
      expression: "step > 0"
    }],
    staticClass: "no-btn blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.backStep()
      }
    }
  }, [_vm._v("Voltar")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step < 3 && _vm.aggregate),
      expression: "step < 3 && aggregate"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextStep()
      }
    }
  }, [_vm._v("\n          Avançar\n          "), _c('i', {
    staticClass: "icon-circle-right"
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 3),
      expression: "step == 3"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.doRequest()
      }
    }
  }, [_vm._v("\n          Finalizar\n          "), _c('i', {
    staticClass: "icon-tick"
  })])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-step"
  }, [_c('i', {
    staticClass: "icon-tick"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-step"
  }, [_c('i', {
    staticClass: "icon-tick"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-step"
  }, [_c('i', {
    staticClass: "icon-tick"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-step"
  }, [_c('i', {
    staticClass: "icon-tick"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-6ea9ddd1!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/aggregate/modal/modal-toll-ticket.vue
// module id = 2164
// module chunks = 1